/* Product page review cards (Judge.me widget), Jeremy 2026-09-25:
   - every card has an image column: the review's photos, or — when there are none — the photo
     of the sandal variant the reviewer bought (from the "Variant:" line), else the product photo;
   - multiple photos show as one main photo plus small thumbnails (no horizontal scroll bar);
   - the store reply reads "Reply from Shamma Sandals" without the ">>" prefix.
   Judge.me renders and paginates reviews itself, so cards are enhanced as they appear. */
(() => {
  const root = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
  if (!root) return;
  const productUrl = location.pathname.split('?')[0].replace(/\/$/, '');
  let productPromise;
  const product = () => {
    productPromise = productPromise || fetch(`${productUrl}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    return productPromise;
  };
  const sized = (src, width) => {
    if (!src) return '';
    const url = src.startsWith('//') ? `https:${src}` : src;
    return url + (url.includes('?') ? '&' : '?') + `width=${width}`;
  };
  const imageFor = (data, variantText) => {
    if (!data) return null;
    const parts = (variantText || '').toLowerCase().split('/').map((p) => p.trim()).filter(Boolean);
    let best = null;
    let bestScore = 0;
    if (parts.length) {
      data.variants.forEach((v) => {
        if (!v.featured_image) return;
        const score = (v.options || []).filter((o) => parts.includes(String(o).toLowerCase())).length;
        if (score > bestScore) { best = v.featured_image.src; bestScore = score; }
      });
    }
    return best || data.featured_image || (data.images && data.images[0]) || null;
  };
  const enhance = (rev) => {
    if (rev.dataset.shRev) return;
    rev.dataset.shRev = '1';
    rev.classList.add('sh-rev');
    const media = document.createElement('div');
    media.className = 'sh-rev-media';
    const pics = rev.querySelector('.jdgm-rev__pics');
    if (pics && pics.querySelector('.jdgm-rev__pic-link')) {
      const count = pics.querySelectorAll('.jdgm-rev__pic-link').length;
      media.dataset.count = String(count);
      if (count > 4) media.dataset.more = `+${count - 4}`;
      if (count > 1) media.dataset.extra = `+${count - 1}`;
      media.append(pics);
    } else {
      media.classList.add('sh-rev-media--product');
      const variantEl = rev.querySelector('.jdgm-rev__prod-variant-wrapper');
      const variantText = variantEl ? variantEl.textContent.replace(/variant:?/i, '') : '';
      product().then((data) => {
        const src = imageFor(data, variantText);
        if (!src) return;
        const img = document.createElement('img');
        img.src = sized(src, 400);
        img.alt = (data && data.title) ? `${data.title}${variantText ? ` — ${variantText.trim()}` : ''}` : '';
        img.loading = 'lazy';
        img.width = 200;
        img.height = 200;
        media.append(img);
      });
    }
    rev.prepend(media);
    const replier = rev.querySelector('.jdgm-rev__replier-wrapper');
    if (replier && !replier.dataset.shDone) {
      replier.dataset.shDone = '1';
      const name = (rev.querySelector('.jdgm-rev__replier') || {}).textContent || 'Shamma Sandals';
      replier.textContent = `Reply from ${name.trim()}`;
    }
  };
  const scan = () => root.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev, .jdgm-rev-widg__reviews > .jdgm-rev').forEach(enhance);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(root, { childList: true, subtree: true });
  scan();
})();
